import {getCachedTableDataSlice, getCachedTableResultSelector} from 'src/hooks/common-data-service/cached-table';

import {userSearchResultStateSelector} from './user-search-result-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';
import type {UserSearchFiltering} from 'src/openapi/admin/models/UserSearchFiltering';
import type {UserSortField} from 'src/openapi/admin/models/UserSortField';

export const userSearchResultNewslettersSlice = getCachedTableDataSlice<
    Record<string, string[]>,
    UserSearchCriteria,
    UserSortField,
    UserSearchFiltering
>('userSearchResultNewsletters');

export const userSearchResultNewslettersActions = userSearchResultNewslettersSlice.actions;

const userSearchResultNewslettersCacheSelector: CachedTableCacheSelector<Record<string, string[]>>
    = state => state.userSearchResult.newsletters.cache;
export const userSearchResultNewslettersDataSelector: CachedTableDataSelector<Record<string, string[]>>
    = state => state.userSearchResult.newsletters;
export const userSearchResultNewslettersResultSelector = getCachedTableResultSelector(
    userSearchResultNewslettersCacheSelector,
    userSearchResultStateSelector,
);
